import * as CookieConsent from "vanilla-cookieconsent";

/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */
CookieConsent.run({
    disablePageInteraction: true,
    // root: 'body',
    // autoShow: true,
    // disablePageInteraction: true,
    // hideFromBots: true,
    // mode: 'opt-in',
    // revision: 0,

    // cookie: {
    //     name: 'cc_cookie',
    // domain: location.hostname,
    // path: '/',
    // sameSite: "Lax",
    // expiresAfterDays: 365,
    // },

    // https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
    guiOptions: {
        consentModal: {
            layout: 'box wide',
            position: 'bottom center',
            equalWeightButtons: false,
            flipButtons: false,
            transition: 'slide'
        },
        preferencesModal: {
            layout: 'box',
            equalWeightButtons: false,
            flipButtons: false,
            transition: 'slide'
        }
    },

    onFirstConsent: ({cookie}) => {
        // registerCookiePreference(cookie)
    },

    onConsent: ({cookie}) => {
        updateGtagConsent();
        updateFBConsent();
    },

    onChange: ({changedCategories, changedServices}) => {
        // registerCookiePreference(changedCategories)
        updateGtagConsent();
        updateFBConsent();
    },

    // onModalReady: ({modalName}) => {
    //     console.log('ready:', modalName);
    // },
    //
    // onModalShow: ({modalName}) => {
    //     console.log('visible:', modalName);
    // },
    //
    // onModalHide: ({modalName}) => {
    //     console.log('hidden:', modalName);
    // },

    categories: {
        necessary: {
            enabled: true,  // this category is enabled by default
            readOnly: true  // this category cannot be disabled
        },
        analytics: {
            autoClear: {
                cookies: [
                    {
                        name: /^_ga/,   // regex: match all cookies starting with '_ga'
                    },
                    {
                        name: '_gid',   // string: exact cookie name
                    }
                ]
            },

            // https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
            services: {
                ga: {
                    label: 'Google Analytics',
                    onAccept: () => {},
                    onReject: () => {}
                },
                // youtube: {
                //     label: 'Youtube Embed',
                //     onAccept: () => {},
                //     onReject: () => {}
                // },
            }
        },
        targeting: {}
    },

    language: {
        default: 'it',
        autoDetect: 'document',
        translations: {
            it: {
                consentModal: {
                    title: ' I Cookie rendono le cose migliori!',
                    description: 'Utilizziamo cookie tecnici necessari al funzionamento del sito e, previo consenso, cookie e dati personali per misurare le prestazioni, migliorare l’esperienza di navigazione e proporre annunci personalizzati, inclusa la personalizzazione degli annunci (“ads personalization”). I dati possono essere condivisi con partner di misurazione e pubblicità, incluso Google, che li tratterà secondo le proprie informative. Puoi accettare tutti i cookie, rifiutare quelli non necessari o personalizzare le tue preferenze. Maggiori informazioni sono disponibili nella Cookie Policy.', //
                    acceptAllBtn: 'Accetto tutti i Cookie',
                    acceptNecessaryBtn: 'Rifiuta tutti',
                    showPreferencesBtn: 'Impostazioni',
                    equalWeightButtons: false
                    // closeIconLabel: 'Reject all and close modal',
                },
                preferencesModal: {
                    title: 'Centro preferenze sulla privacy',
                    acceptAllBtn: 'Accetta tutti',
                    acceptNecessaryBtn: 'Rifiuta tutti',
                    savePreferencesBtn: 'Salva le impostazioni',
                    closeIconLabel: 'Chiudi',
                    serviceCounterLabel: 'Servizio|Servizi',
                    equalWeightButtons: false,
                    sections: [
                        {
                            title: 'Opzioni Cookie',
                            description: 'Questo sito Web utilizza cookie essenziali per garantirne il corretto funzionamento e cookie di tracciamento per capire come interagisci con esso. Quest\'ultimo sarà impostato solo previo consenso.'
                        },
                        {
                            title: 'Cookie strettamente necessari',
                            description: 'Questi cookie sono necessari per il funzionamento del sito e non possono essere disattivati nei nostri sistemi. Di solito vengono impostati solo in risposta alle azioni da te effettuate che costituiscono una richiesta di servizi, come l\'impostazione delle preferenze di privacy, l\'accesso o la compilazione di moduli. È possibile impostare il browser per bloccare o avere avvisi riguardo questi cookie, ma di conseguenza alcune parti del sito non funzioneranno. Questi cookie non archiviano informazioni personali.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Dominio',
                                    desc: 'Descrizione',
                                },
                                body: [
                                    {
                                        name: 'october_session',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Conserva lo stato della sessione del visitatore tra le richieste di pagina.',
                                    },
                                    {
                                        name: 'cc_cookie',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Memorizza lo stato del consenso ai cookie dell\'utente per il dominio corrente.',
                                    },
                                ]
                            }
                        },
                        {
                            title: 'Cookie di analisi e prestazione',
                            description: 'Questi cookie ci permettono di contare le visite e fonti di traffico in modo da poter misurare e migliorare le prestazioni del nostro sito. Ci aiutano a sapere quali sono le pagine più e meno popolari e vedere come i visitatori si muovono intorno al sito. Tutte le informazioni raccolte dai cookie sono aggregate e quindi anonime. Se non consenti questi cookie, non sapremo quando hai visitato il nostro sito.',
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Dominio',
                                    desc: 'Descrizione'
                                },
                                body: [
                                    {
                                        name: '_ga',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet',
                                    },
                                    {
                                        name: '_gid',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet',
                                    },
                                    {
                                        name: '_gat',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Utilizzato da Google Analytics per limitare la frequenza delle richieste',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Cookie per pubblicità mirata',
                            description: 'Questi cookie possono essere impostati tramite il nostro sito dai nostri partner pubblicitari. Possono essere utilizzati da queste aziende per costruire un profilo dei tuoi interessi e mostrarti annunci pertinenti su altri siti. Non memorizzano direttamente informazioni personali, ma sono basati unicamente sull/individuazione del tuo browser e del tuo dispositivo internet. Se non si accettano questi cookie, riceverai una pubblicità meno mirata.',
                            linkedCategory: 'targeting',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Descrizione'
                                },
                                body: [
                                    {
                                        name: '_fbp',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.  ',
                                    },
                                    {
                                        name: 'mtc_id',
                                        domain: window.location.hostname,
                                        desc: "HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.  ",
                                    },
                                    {
                                        name: 'mautic_device_id',
                                        domain: window.location.hostname,
                                        desc: "HTTP - Utilizzato per identificare il visitatore attraverso le visite e i dispositivi. Ciò consente al sito web di presentare il visitatore con Pubblicità pertinente - Il servizio è fornito da centri pubblicitari di terze parti, che facilitano le offerte in tempo reale per gli inserzionisti. ",
                                    },
                                    {
                                        name: 'mautic_referer_id',
                                        domain: window.location.hostname,
                                        desc: "HTTP - Raccoglie informazioni sul comportamento degli utenti su più siti web. Queste informazioni vengono utilizzate per ottimizzare la pertinenza della pubblicità sul sito web.  ",
                                    },
                                    {
                                        name: 'mtc_sid',
                                        domain: window.location.hostname,
                                        desc: "HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.  ",
                                    },
                                    {
                                        name: '_gcl_au',
                                        domain: window.location.hostname,
                                        desc: "Google - Utilizzato da Google Ads per misurare l'efficacia delle campagne pubblicitarie.",
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Maggiori informazioni',
                            description: 'Per maggiori informazioni consulta la nostra <a href="/privacy-policy" class="cc-link">privacy policy</a> e la <a href="/cookie-policy" class="cc-link">cookie policy</a>.',
                        }
                    ]
                }
            } ,
            en: {
                consentModal: {
                    title: 'Cookies make things better! ',
                    description: 'We use technical cookies that are necessary for the website to function and, subject to your consent, cookies and personal data to measure performance, improve the browsing experience, and provide personalized ads ("ads personalization"). Data may be shared with measurement and advertising partners, including Google, who will process it in accordance with their own policies. You can accept all cookies, reject non-essential cookies, or customize your preferences. More information is available in the Cookie Policy.',
                    acceptAllBtn: 'Accept all Cookies',
                    acceptNecessaryBtn: 'Reject all',
                    showPreferencesBtn: 'Settings',
                    equalWeightButtons: false
                    // closeIconLabel: 'Reject all and close modal',
                },
                preferencesModal: {
                    title: 'Privacy Preference Centre',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    savePreferencesBtn: 'Save settings',
                    closeIconLabel: 'Close',
                    serviceCounterLabel: 'Service|Services',
                    equalWeightButtons: false,
                    sections: [
                        {
                            title: 'Cookie Options',
                            description: 'This website uses essential cookies to ensure it works properly and tracking cookies to understand how you interact with it. The latter will only be set with your consent.'
                        },
                        {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are necessary for the operation of the site and cannot be disabled in our systems. They are usually set only in response to actions you take that constitute a request for services, such as setting privacy preferences, logging in, or filling out forms. You can set your browser to block or have warnings about these cookies, but as a result some parts of the site will not work. These cookies do not store personal information.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Description',
                                },
                                body: [
                                    {
                                        name: 'october_session',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Preserves the visitor\'s session state between page requests.'
                                    },
                                    {
                                        name: 'cc_cookie',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Stores the user\'s cookie consent status for the current domain.',
                                    },
                                ]
                            }
                        },
                        {
                            title: 'Analytics and performance cookies',
                            description: 'These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us know which pages are the most and least popular and see how visitors move around the site. All information collected by cookies is aggregated and therefore anonymous. If you do not allow these cookies, we will not know when you visited our site.',
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Description',
                                },
                                body: [
                                    {
                                        name: '_ga',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Records a unique ID used to generate statistical data on how the visitor uses the website',
                                    },
                                    {
                                        name: '_gid',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Records a unique ID used to generate statistical data on how the visitor uses the website',
                                    },
                                    {
                                        name: '_gat',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Used by Google Analytics to limit the frequency of requests',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Cookies for targeted advertising',
                            description: 'These cookies may be set through our site by our advertising partners. They can be used by these companies to build a profile of your interests and show you relevant ads on other sites. They do not directly store any personal information, but are based solely on/on the tracking of your Internet browser and device. If you do not accept these cookies, you will receive less targeted advertising.',
                            linkedCategory: 'targeting',

                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Description',
                                },
                                body: [
                                    {
                                        name: '_fbp',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Used to track visitors on multiple Web sites in order to display relevant recent advertisements based on the visitor\'s preferences.  ',
                                    },
                                    {
                                        name: 'mtc_id',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Used to track visitors on multiple Web sites in order to display relevant recent advertisements based on the visitor\'s preferences.  ',
                                    },
                                    {
                                        name: 'mautic_device_id',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Used to identify the visitor across visits and devices. This allows the website to present the visitor with Relevant Advertising - The service is provided by third-party advertising centers, which facilitate real-time bidding for advertisers.',
                                    },
                                    {
                                        name: 'mautic_referer_id',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Collects information about user behavior on multiple websites. This information is used to optimize the relevance of advertising on the website.',
                                    },
                                    {
                                        name: 'mtc_sid',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Used to track visitors on multiple Web sites in order to display relevant recent advertisements based on the visitor\'s preferences.',
                                    },
                                    {
                                        name: '_gcl_au',
                                        domain: window.location.hostname,
                                        desc: 'Google - Used by Google Ads to measure the effectiveness of advertising campaigns.',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'More information',
                            description: 'For more information see our <a href="/en/privacy-cookie" class="cc-link">privacy policy and cookie policy</a>.',
                        }
                    ]
                }
            }
        }
    }
});

const updateGtagConsent = () => {
    const consentMode = {
        'ad_storage': CookieConsent.acceptedCategory('targeting') ? 'granted' : 'denied',
        'ad_user_data': CookieConsent.acceptedCategory('targeting') ? 'granted' : 'denied',
        'ad_personalization': CookieConsent.acceptedCategory('targeting') ? 'granted' : 'denied',
        'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        'functionality_storage': CookieConsent.acceptedCategory('functional') ? 'granted' : 'denied',
        'personalization_storage': CookieConsent.acceptedCategory('functional') ? 'granted' : 'denied',
        'security_storage': 'granted', //necessary
        // 'region': ['IT', 'ES','AL','AT','BE','BG']
        // 'wait_for_update': 500
    };

    gtag('consent', 'update', consentMode);
};

const updateFBConsent = () => {
    fbq('consent', CookieConsent.acceptedCategory('targeting') ? 'grant' : 'revoke');
};

function registerCookiePreference() {
    let cookiEntries = {
        'targeting': CookieConsent.acceptedCategory('targeting') ? '1' : '0',
        'analytics': CookieConsent.acceptedCategory('analytics') ? '1' : '0',
    }

    $.request('onLogEntries',{
        data: {cookiEntries: cookiEntries},
    })
}

window.trackAdsConversion = function(value = 10){
    if (CookieConsent.acceptedCategory('targeting')) {
        gtag('event', 'conversion', {
            'send_to': 'AW-17711818375/ZJpBCM27xokcEIfN0_1B',
            'value': value,
            'currency': 'EUR'
        });

    }

};

window.trackGtagEvent = function(eventName = "form_contatti_generico", dataPush = ""){
    if (CookieConsent.acceptedCategory('analytics')) {
        gtag('event', eventName, dataPush);
    }
};

window.trackFbqEvent = function(eventName = "Lead", dataPush = ""){
    if (CookieConsent.acceptedCategory('targeting')) {
        if (eventName == "Lead") {
            fbq('track', 'Lead');
        } else {
            fbq('trackCustom', eventName, dataPush);
        }
    }
};


if (CookieConsent.acceptedCategory('targeting')) {
    fbq('consent', 'grant');
}
